function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.78547 10.6511L6.1763 10.2195L6.83214 7.77031C5.85044 7.40825 4.93807 6.88061 4.13464 6.21031L2.34047 8.00531L1.1613 6.82615L2.9563 5.03198C1.94303 3.81845 1.26221 2.36261 0.980469 0.806979L2.62047 0.507812C3.25297 4.00948 6.3163 6.66615 10.0005 6.66615C13.6838 6.66615 16.748 4.00948 17.3805 0.507812L19.0205 0.806146C18.7391 2.36199 18.0586 3.81812 17.0455 5.03198L18.8396 6.82615L17.6605 8.00531L15.8663 6.21031C15.0629 6.88061 14.1505 7.40825 13.1688 7.77031L13.8246 10.2203L12.2155 10.6511L11.5588 8.20115C10.5274 8.37788 9.47351 8.37788 8.44214 8.20115L7.78547 10.6511Z",
  fill: "#293749"
});

var SvgEyeClose = function SvgEyeClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-close.df46b2ea.svg";
export { ForwardRef as ReactComponent };